import React from "react";
import ReactDOM from "react-dom";

import LoadFileErrorPanel from "./components/LoadFileErrorPanel";
import { LoadFileError } from "./gen/ClientState";
import { PathRelFile } from "./gen/Path";

export class LoadFileErrorPanelContainer {
  constructor(private root: HTMLElement) {}

  showPanel(filePath: PathRelFile | null, data: LoadFileError): void {
    ReactDOM.render(<LoadFileErrorPanel filePath={filePath} data={data} />, this.root);
  }

  hide(): void {
    ReactDOM.unmountComponentAtNode(this.root);
  }
}
